module.exports = __webpack_public_path__ + "static/media/iconSelect.b96d9654.svg";